// Central place for all image URLs used across the site.
// Vehicle image = customer's own photograph (uploaded).
// Monument/landscape photography = curated Unsplash real photos matching each place.

export const WHATSAPP_URL = "https://wa.me/351931880078";
export const CONTACT_EMAIL = "christianjunio0611@icloud.com";

// Fires a Google Ads conversion when a WhatsApp CTA is clicked.
// WhatsApp links open in a new tab (target="_blank"), so we DO NOT use the
// event_callback redirect — we just fire-and-forget the conversion event.
export const trackWhatsAppConversion = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
            send_to: "AW-18312841808/V6deCNzZgdEcENCUn5xE",
        });
    }
};

export const IMAGES = {
    hero_palacio_da_pena:
        "https://images.unsplash.com/photo-1731273500789-7c9defe5a483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxQZW5hJTIwUGFsYWNlJTIwU2ludHJhfGVufDB8fHx8MTc4MzE5MTYxNHww&ixlib=rb-4.1.0&q=85",
    vehicle:
        "https://customer-assets.emergentagent.com/job_92875fb1-17b0-44d1-bf2d-23ccaf921ef0/artifacts/sf0mio56_9a0c5bbb-3797-403d-be46-b8eda3b4aa31.jpg",
    palacio_da_pena:
        "https://images.unsplash.com/photo-1731273500789-7c9defe5a483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxQZW5hJTIwUGFsYWNlJTIwU2ludHJhfGVufDB8fHx8MTc4MzE5MTYxNHww&ixlib=rb-4.1.0&q=85",
    palacio_nacional_sintra:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/9enz1bkw_image.jpeg",
    chalet_biester:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/6uy54nph_image.jpeg",
    vale_dos_lagos:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/nlzahfl4_image.jpeg",
    castelo_dos_mouros:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/qbtxuj8v_image.jpeg",
    azenhas_do_mar:
        "https://images.unsplash.com/photo-1655369000751-1998213b0ea5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxBemVuaGFzJTIwZG8lMjBNYXJ8ZW58MHx8fHwxNzgzMTkxNjI4fDA&ixlib=rb-4.1.0&q=85",
    praia_das_macas:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/if7636p1_image.jpeg",
    cabo_da_roca:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Portugal_Cabo-da-Roca-Lighthouse-03.jpg/1920px-Portugal_Cabo-da-Roca-Lighthouse-03.jpg",
    cascais:
        "https://images.unsplash.com/photo-1587973878097-ef3aabd5eeaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxDYXNjYWlzJTIwUG9ydHVnYWx8ZW58MHx8fHwxNzgzMTkxNjE0fDA&ixlib=rb-4.1.0&q=85",
    boca_do_inferno:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/h8plhoqy_image.webp",
    praia_da_adraga:
        "https://images.unsplash.com/photo-1579718311580-4577a67ce957?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxQcmFpYSUyMGRhJTIwQWRyYWdhfGVufDB8fHx8MTc4MzE5MTYyMXww&ixlib=rb-4.1.0&q=85",
    praia_do_guincho:
        "https://images.unsplash.com/photo-1725984002189-e150d594975c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxQcmFpYSUyMGRvJTIwR3VpbmNob3xlbnwwfHx8fDE3ODMxOTE2MjF8MA&ixlib=rb-4.1.0&q=85",
    fatima:
        "https://images.unsplash.com/photo-1633887270356-32279da5ae91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxGYXRpbWElMjBTYW5jdHVhcnklMjBQb3J0dWdhbHxlbnwwfHx8fDE3ODMxOTE2MjF8MA&ixlib=rb-4.1.0&q=85",
    nazare:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/jg6bkoq9_image.jpeg",
    obidos:
        "https://customer-assets.emergentagent.com/job_luxury-travel-pt-1/artifacts/tiucdaet_image.png",
};

// Ticket links
export const TICKET_LINKS = {
    pena: "https://bilheteira.parquesdesintra.pt/evento/parque-e-palacio-da-pena-visita-essencial/1169/pt",
    regaleira:
        "https://book.quintadaregaleiratickets.com/book/20027/select/?cookieBanner=false&currencyCode=EUR",
};

// Google Maps embed for Rua do Cabeço 7, Sintra (plus code RJ57+276)
// Using a simple ?q= embed which does not require an API key.
export const GOOGLE_MAPS_EMBED =
    "https://www.google.com/maps?q=Rua+do+Cabe%C3%A7o+7,+Sintra,+Portugal+(RJ57%2B276)&output=embed";
export const GOOGLE_MAPS_LINK =
    "https://www.google.com/maps/place/RJ57%2B276+Sintra,+Portugal";

// Ordered gallery list (label key → image key)
export const GALLERY_ORDER = [
    { key: "palacio_da_pena", label: "Palácio da Pena" },
    { key: "palacio_nacional_sintra", label: "Palácio Nacional de Sintra" },
    { key: "castelo_dos_mouros", label: "Castelo dos Mouros" },
    { key: "chalet_biester", label: "Chalet Biester" },
    { key: "vale_dos_lagos", label: "Vale dos Lagos" },
    { key: "cabo_da_roca", label: "Cabo da Roca" },
    { key: "cascais", label: "Cascais" },
    { key: "boca_do_inferno", label: "Boca do Inferno" },
    { key: "praia_da_adraga", label: "Praia da Adraga" },
    { key: "praia_do_guincho", label: "Praia do Guincho" },
    { key: "azenhas_do_mar", label: "Azenhas do Mar" },
    { key: "praia_das_macas", label: "Praia das Maçãs" },
    { key: "nazare", label: "Nazaré" },
    { key: "fatima", label: "Fátima" },
    { key: "obidos", label: "Óbidos" },
];

// Tours → image mapping (indexes match translations.tours.items)
export const TOUR_IMAGES = [
    // Sintra Imperial → hero of the tour = Palácio da Pena; also carousel-worthy alternates
    {
        cover: IMAGES.palacio_da_pena,
        thumbs: [
            IMAGES.palacio_nacional_sintra,
            IMAGES.chalet_biester,
            IMAGES.vale_dos_lagos,
            IMAGES.castelo_dos_mouros,
        ],
    },
    // Encantos da Costa
    {
        cover: IMAGES.azenhas_do_mar,
        thumbs: [IMAGES.praia_das_macas],
    },
    // Cabo da Roca
    { cover: IMAGES.cabo_da_roca, thumbs: [] },
    // Cascais
    {
        cover: IMAGES.cascais,
        thumbs: [
            IMAGES.boca_do_inferno,
            IMAGES.praia_do_guincho,
        ],
    },
    // Fé, Mar e História
    {
        cover: IMAGES.fatima,
        thumbs: [IMAGES.nazare, IMAGES.obidos],
    },
];

// Per-tour photo gallery — one real image per visited place (order matches translations.tours.items[i].places)
export const TOUR_GALLERIES = [
    // 0. Sintra Imperial
    [
        IMAGES.palacio_nacional_sintra,
        IMAGES.chalet_biester,
        IMAGES.palacio_da_pena,
        IMAGES.vale_dos_lagos,
        IMAGES.castelo_dos_mouros,
    ],
    // 1. Encantos da Costa de Sintra
    [IMAGES.azenhas_do_mar, IMAGES.praia_das_macas],
    // 2. Cabo da Roca
    [IMAGES.cabo_da_roca],
    // 3. Cascais Premium
    [
        IMAGES.cascais,
        IMAGES.boca_do_inferno,
        IMAGES.praia_do_guincho,
    ],
    // 4. Fé, Mar e História
    [IMAGES.fatima, IMAGES.nazare, IMAGES.obidos],
];
